import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../axios";
import qs from "qs";
import Alert from "react-s-alert";



class EditModalOrder extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isButtonLoading: false,
            isLoading: false,
            orderId: this.props.orderId
        };

        this.handleToggle = this.handleToggle.bind(this);
        this.handleSubmitSoal = this.handleSubmitSoal.bind(this);
        this.handleChangeOrder = this.handleChangeOrder.bind(this);
    }

    handleSubmitSoal() {

        this.setState({ isButtonLoading: true });
        const url = '/ujian/soal/uporder';

        let newState = {
            exam_id: this.props.examId,
            question_id: this.props.quesId,
            order_id: this.state.orderId
        };


        axios({
            method: "post",
            url: url,
            data: qs.stringify(newState)
        })

            .then(response => {
                const result = response.data;

                if (result.success) {
                    window.location.reload();
                    Alert.success(result.message);
                } else {
                    if (Array.isArray(result.message)) {
                        result.message.map(item => {
                            Alert.error(item);
                            return true;
                        });
                    } else {
                        Alert.error(result.message);
                    }

                    this.setState({ isButtonLoading: false });
                }
            })

            .catch(error => {
                console.log(error);
                this.setState({ isButtonLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    handleChangeOrder(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleToggle() {
        this.props.toggleModalEditOrder()
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.handleToggle} className="modal-primary">
                <ModalHeader toggle={this.handleToggle}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    {/*Form*/}
                    <div className="card">
                        <div className="card-header">{this.props.mode} {this.props.modalBodyText}</div>
                        <div className="card-block">
                            {this.state.isLoading ? (
                                "Memuat Data..."
                            ) : (
                                <div className="form-horizontal animated fadeIn">
                                    <div className="col-md-12">
                                        Saat ini urutan soal berada di nomor {this.props.orderId}
                                    </div>
                                    <div>
                                        <div className="form-group">
                                            <label className="col-md-12 form-control-label">
                                                Pindah ke urutan?
                                            </label>
                                            <div className="col-md-12">
                                                <input
                                                    name="orderId"
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Order"
                                                    onChange={this.handleChangeOrder}
                                                    value={this.state.orderId != '' ? this.state.orderId : this.props.orderId}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" disabled={this.state.isButtonLoading && "disabled"}  onClick={this.handleSubmitSoal}>{this.state.isButtonLoading ? "Loading" : "Simpan"}</Button>{' '}
                    <Button color="secondary" onClick={this.handleToggle}>Batal</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

EditModalOrder.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    toggleModalEditOrder: PropTypes.func.isRequired,
    orderId: PropTypes.number.isRequired,
    quesId: PropTypes.number.isRequired,
    examId: PropTypes.number.isRequired
}

export default EditModalOrder


// WEBPACK FOOTER //
// ./src/components/EditModalOrder.js